import {toAbsoluteUrl} from '../../_metronic/helpers'

export const languages = {
  ENGLISH: 'en',
  SPANISH: 'es',
  FRENCH: 'fr',
  GERMAN: 'de',
  POLISH: 'pl',
  PORTUGUESE: 'pt',
  ITALIAN: 'it',
  NETHERLANDS: 'nl',
  RUSSIAN: 'ru',
  JAPANESE: 'ja',
  CHINESE: 'zh',
}

export const languagesInEnglish: Record<string, string> = {
  English: 'en',
  Spanish: 'es',
  French: 'fr',
  German: 'de',
  Polish: 'pl',
  Portuguese: 'pt',
  Italian: 'it',
  Dutch: 'nl',
  Russian: 'ru',
  Japanese: 'ja',
  Chinese: 'zh',
}
export const languageLabels: {[key: string]: string} = {
  [languages.ENGLISH]: 'English',
  [languages.SPANISH]: 'Español - Spanish',
  [languages.GERMAN]: 'Deutsch - German',
  [languages.FRENCH]: 'Français - French',
  [languages.POLISH]: 'Polski - Polish',
  [languages.PORTUGUESE]: 'Português - Portuguese',
  [languages.ITALIAN]: 'Italiano - Italian',
  [languages.NETHERLANDS]: 'Nederlands - Dutch',
  [languages.RUSSIAN]: 'Русский - Russian',
  [languages.JAPANESE]: '日本語 - Japanese',
  [languages.CHINESE]: '简体中文 - Simplified Chinese',
  // id: 'Bahasa Indonesia - Indonesian',
  // msa: 'Bahasa Melayu - Malay',
  // ca: 'Català - Catalan',
  // cs: 'Čeština - Czech',
  // da: 'Dansk - Danish',
  // 'en-gb': 'English UK - British English',
  // fil: 'Filipino',
  // ga: 'Gaeilge - Irish (beta)',
  // gl: 'Galego - Galician (beta)',
  // hr: 'Hrvatski - Croatian',
  // hu: 'Magyar - Hungarian',
  // no: 'Norsk - Norwegian',
  // ro: 'Română - Romanian',
  // sk: 'Slovenčina - Slovak',
  // fi: 'Suomi - Finnish',
  // sv: 'Svenska - Swedish',
  // vi: 'Tiếng Việt - Vietnamese',
  // tr: 'Türkçe - Turkish',
  // el: 'Ελληνικά - Greek',
  // bg: 'Български език - Bulgarian',
  // sr: 'Српски - Serbian',
  // uk: 'Українська мова - Ukrainian',
  // he: 'עִבְרִית - Hebrew',
  // ur: 'اردو - Urdu (beta)',
  // ar: 'العربية - Arabic',
  // fa: 'فارسی - Persian',
  // mr: 'मराठी - Marathi',
  // hi: 'हिन्दी - Hindi',
  // bn: 'বাংলা - Bangla',
  // gu: 'ગુજરાતી - Gujarati',
  // ta: 'தமிழ் - Tamil',
  // kn: 'ಕನ್ನಡ - Kannada',
  // th: 'ภาษาไทย - Thai',
  // ko: '한국어 - Korean',
  // 'zh-tw': '繁體中文 - Traditional Chinese',
}

export const languageFlags = {
  [languages.ENGLISH]: toAbsoluteUrl('/media/flags/united-states.svg'),
  [languages.CHINESE]: toAbsoluteUrl('/media/flags/china.svg'),
  [languages.SPANISH]: toAbsoluteUrl('/media/flags/spain.svg'),
  [languages.SPANISH]: toAbsoluteUrl('/media/flags/japan.svg'),
  [languages.GERMAN]: toAbsoluteUrl('/media/flags/germany.svg'),
  [languages.FRENCH]: toAbsoluteUrl('/media/flags/france.svg'),
}

export default languages
